import * as FiIcons from 'react-icons/fi';

const { FiCode, FiSmartphone, FiShoppingCart, FiTrendingUp, FiMonitor, FiGlobe } = FiIcons;

export const projectsData = [
  {
    id: 12,
    slug: 'domestic-appliance-repairz-website',
    title: 'Domestic Appliance Repairz',
    category: 'Trade',
    description: 'Complete website build for a local Aylesbury appliance repair company, boosting visibility and generating consistent service bookings.',
    shortDescription: 'Professional appliance repair website with fast call-out feature, home, about, services and contact us pages.',
    image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=600&h=400&fit=crop',
    tags: ['WordPress', 'Local SEO', 'Emergency Callouts', 'Mobile First'],
    client: 'Domestic Appliance Repairz',
    location: 'Aylesbury, Buckinghamshire',
    duration: '5 weeks',
    year: '2024',
    services: ['Web Design', 'Local SEO', 'Content Creation', 'Ongoing Support'],
    challenge: 'Domestic Appliance Repairz had no professional online presence, making it difficult for customers to find and trust their services. Competitors with established websites were winning most of the local work.',
    solution: 'We designed a clean, mobile-first website focused on urgent appliance repairs. Clear call-to-action buttons, service area coverage, and emergency contact forms made it easy for customers to book fast. We also optimised the site for local SEO to rank in Aylesbury and surrounding areas.',
    results: [
      '150% increase in enquiries within 2 months of launch',
      'Page 1 Google rankings for "appliance repairs Aylesbury"',
      'Steady flow of new service calls every week',
      'Increased customer trust with testimonials and service guarantees'
    ],
    gallery: [
      '/images/clients/webp/abactus-1-m.webp',
      '/images/clients/webp/abactus-0.webp',
      '/images/clients/webp/abactus-2.webp',
      '/images/clients/webp/abactus-3.webp',
      '/images/clients/webp/abactus-4.webp',
      '/images/clients/webp/abactus-5.webp',
      '/images/clients/webp/abactus-6.webp',
      '/images/clients/webp/abactus-7.webp',
    ],
    testimonial: {
      content: "Our website now brings in regular repair jobs every week. Customers often tell us they chose us because the website looked professional and easy to use.",
      author: 'Naz Shah',
      role: 'Owner, Domestic Appliance Repairz'
    },
    techStack: ['WordPress', 'PHP', 'MySQL', 'Google Analytics', 'Local SEO'],
    features: [
      'Responsive mobile design',
      'Emergency call-out forms',
      'Service area mapping',
      'Customer testimonials',
      'Fast contact buttons (call/WhatsApp)',
      'Before/after repair galleries'
    ],
    url: 'https://domesticappliancerepairz.co.uk'
  },
  {
    id: 13,
    slug: 'tappr-website',
    title: 'Tappr Digital',
    category: 'Transportation',
    description: 'A scalable peer-to-peer bike rental website built for Tappr, helping local communities in Leicestershire access affordable and sustainable transport. The platform connects bike owners with renters, enabling secure bookings and payments online.',
    shortDescription: 'Community-focused bike rental website making cycling more accessible and sustainable.',
    image: 'https://images.unsplash.com/photo-1455641374154-422f32e234cd?w=600&h=400&fit=crop',
    tags: ['Digital Transformation', 'eCommerce', 'SaaS', 'Stripe'],
    client: 'Tappr',
    location: 'Leicestershire, UK',
    duration: '6 weeks',
    year: '2024',
    services: ['Web Development', 'Digital Strategy', 'Payment Integration', 'UX Design'],
    challenge: 'Tappr identified a growing demand for affordable, eco-friendly transport solutions in local communities. They needed a platform that would allow individuals to easily rent bikes from nearby owners, with a secure booking system and trusted payment process.',
    solution: 'We designed and developed a fully-featured rental platform that makes it simple for users to find, book, and pay for bikes online. Owners can list their bikes, manage availability, and respond to reviews. The platform includes a seamless Stripe integration for secure transactions and a user-friendly experience to encourage repeat bookings.',
    results: [
      'Launched a new revenue-generating bike rental service in Leicestershire',
      'Enabled local bike owners to earn passive income from unused bikes',
      'Built trust with users through secure payments and verified reviews',
      'Created a scalable platform with potential to expand nationally'
    ],
    gallery: [
      '/images/clients/webp/tappr-calendar.webp',
      '/images/clients/webp/tappr-home.webp',
      '/images/clients/webp/tappr-payment.webp',

    ],
    testimonial: {
      content: "The platform has completely changed how people access bikes locally. It’s simple to use, secure, and has helped us grow a loyal user base from day one.",
      author: 'James Patel',
      role: 'Founder, Tappr'
    },
    techStack: ['.NET Core', 'Entity Framework', 'MS SQL', 'Stripe API'],
    features: [
      'Peer-to-peer bike rentals',
      'Secure online payments with Stripe',
      'Owner and renter dashboards',
      'Ratings and review system',
      'Availability and booking management',
      'Mobile-friendly responsive design'
    ],
    url: ''
  },
  {
    id: 15,
    slug: 'shieldflare-website',
    title: 'Shieldflare',
    category: 'Cybersecurity SaaS Website',
    description: 'We developed a modern website for Shieldflare, an intelligent analysis platform that helps security teams and network administrators detect misconfigurations, policy conflicts, and security gaps in enterprise firewalls. The website highlights their product’s strengths while ensuring a professional and trustworthy digital presence.',
    shortDescription: 'High-performance SaaS website for a cybersecurity platform providing actionable insights for firewall security.',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop',
    tags: ['Cybersecurity', 'SaaS', 'React.js', 'Tech Startup'],
    client: 'Shieldflare',
    location: 'United Kingdom',
    duration: '4 weeks',
    year: '2025',
    services: ['Web Development', 'UI/UX Design', 'Branding Support'],
    challenge: 'Shieldflare needed a professional website to launch their intelligent analysis platform. The challenge was to communicate a highly technical cybersecurity product in a clear and engaging way that would appeal to IT managers, CISOs, and enterprise security teams.',
    solution: 'We built a responsive, React.js-powered website that showcases Shieldflare’s value proposition with clarity and authority. The site explains how the platform detects firewall misconfigurations, policy conflicts, and security gaps across Palo Alto, Fortinet, and Cisco firewalls, while highlighting actionable insights and efficiency gains. A clean, modern design builds trust with enterprise clients and investors alike.',
    results: [
      'Successfully positioned Shieldflare as a credible cybersecurity SaaS provider',
      'Improved clarity of messaging for technical and non-technical audiences',
      'Delivered a scalable website aligned with Shieldflare’s growth plans',
      'Created a strong foundation for lead generation and investor outreach'
    ],
    gallery: [
      '/images/clients/webp/shieldflare-0.webp',
      '/images/clients/webp/shieldflare-1.2.webp',
      '/images/clients/webp/shieldflare-1.3.webp',
      '/images/clients/webp/shieldflare-1.4.webp',
      '/images/clients/webp/shieldflare-1.5.webp',
      '/images/clients/webp/shieldflare-1.6.webp',
    ],
    testimonial: {
      content: "The new website communicates our product vision clearly and positions us as a serious player in the cybersecurity market. Exactly what we needed for our launch.",
      author: 'Daniel Roberts',
      role: 'Founder, Shieldflare'
    },
    techStack: ['React.js', 'Tailwind CSS', 'Netlify'],
    features: [
      'Responsive SaaS landing pages',
      'Clear product feature breakdown',
      'Industry-focused messaging (Palo Alto, Fortinet, Cisco)',
      'Modern UI/UX design',
      'Optimised for speed and performance',
      'Scalable architecture for future content expansion'
    ],
    url: 'https://shieldflare.wedesignedit.co.uk/'
  },
  {
    id: 10,
    slug: 'al-quds-acadnemy-website',
    title: 'Al-Quds Academy',
    category: 'Charities & Non-Profits',
    description: 'Complete website redesign for a London based charity, resulting in 300% increase in online enquiries.',
    shortDescription: 'Professional website for a charity with online donations, digital education platform, and public wesbite.',
    image: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?w=600&h=400&fit=crop',
    tags: ['Local SEO', 'Online Donations', 'Mobile First'],
    client: 'Al-Quds Academy',
    location: 'United Kingdom',
    duration: '3 weeks',
    year: '2024',
    services: ['Web Design', 'Local SEO', 'Content Creation', 'Ongoing Support'],
    challenge: 'Al-Quds Academy needed a online presence so they could fund raise donations for there local projects. They needed a professional website that would build trust and make it easy for the public support there local projects.',
    solution: 'We created a modern, mobile-first website with clear calls-to-action, integrated donation system via Stripe, and a back office digital education platform. Local SEO optimization ensured they appeared in local search results.',
    results: [
      '300% increase in online enquiries within 3 months',
      '95% of new donors now find them online',
      'Average 4-5 new donations per week from website',
      'Helped fund raise over £10,000 in first 6 months'
    ],
    gallery: [
      '/images/clients/webp/alquds-home.webp',
      '/images/clients/webp/alquds-about.webp',
      '/images/clients/webp/alquds-donation.webp',
      '/images/clients/webp/alquds-enrol.webp',
      '/images/clients/webp/alquds-events.webp',
    ],
    testimonial: {
      content: "wedesignedit has helped us create a professional website that has increased our donations and helped us reach more people in need. The team was fantastic to work with from start to finish.",
      author: 'Yahya Ben Hassen',
      role: 'Director, Al-Quds Academy'
    },
    techStack: ['Next.js', 'Stripe', 'Google Analytics', 'Local SEO'],
    features: [
      'Responsive mobile design',
      'Online donation system',
      'Digital education platform',
      'Mentor forms',
    ],
    url: 'https://www.alqudsacademy.org/'
  },
    {
    id: 14,
    slug: 'auk-airport-service-website',
    title: 'AUK Airport Service',
    category: 'Transportation',
    description: 'A modern, mobile-first website built for AUK Airport Service, a trusted school transport and airport drop-off/pick-up company in Aylesbury. The site makes it easy for customers to book a taxi, view prices, and get in touch instantly via WhatsApp.',
    shortDescription: 'Mobile-first taxi booking website with WhatsApp integration and clear pricing pages.',
    image: 'https://images.unsplash.com/photo-1609510889785-739484fab5f3?h=400&fit=crop',
    tags: ['Transport', 'Mobile First', 'Local Business', 'WhatsApp Integration'],
    client: 'AUK Airport Service',
    location: 'Aylesbury, Buckinghamshire',
    duration: '2 weeks',
    year: '2024',
    services: ['Web Development', 'Mobile-first Design', 'UX Design', 'Messaging Integration'],
    challenge: 'AUK Airport Service needed a simple but professional website that would help local families and travellers easily book school runs and airport transfers. Their business relied heavily on phone calls, which made it difficult to manage bookings efficiently.',
    solution: 'We designed and developed a clean, mobile-first website with a clear structure: Home, About, Prices, and Contact pages. We integrated WhatsApp for instant communication and built a user-friendly booking form so customers can request a taxi in just a few taps.',
    results: [
      'Increased online bookings and reduced reliance on phone calls',
      'Improved customer experience with mobile-first design',
      'Faster response times through WhatsApp integration',
      'Strengthened credibility with a professional online presence'
    ],
    gallery: [
      '/images/clients/webp/auk-all.webp',
      '/images/clients/webp/auk-home.webp',
      '/images/clients/webp/auk-booking.webp',
      '/images/clients/webp/auk-about.webp',
    ],
    testimonial: {
      content: "The new website has made it so much easier for our customers to book with us. We get more enquiries through WhatsApp and the site looks very professional.",
      author: 'Arshad Khan',
      role: 'Owner, AUK Airport Service'
    },
    techStack: ['HTML5', 'CSS3', 'JavaScript', 'Bootstrap'],
    features: [
      'Mobile-first responsive design',
      'WhatsApp integration for instant messaging',
      'Clear pricing page',
      'Simple taxi booking form',
      'About and contact pages',
      'SEO-optimised for local searches'
    ],
    url: ''
  },
  // {
  //   id: 3,
  //   slug: 'diamond-domestic-cleaning-website',
  //   title: 'Diamond Domestic Cleaning',
  //   category: 'Cleaning Business',
  //   description: 'Complete digital transformation for cleaning company including website, booking system, and customer management.',
  //   shortDescription: 'Modern cleaning business website with online booking and customer management system.',
  //   image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=400&fit=crop',
  //   tags: ['Mobile First', 'Booking System', 'CRM'],
  //   client: 'Diamond Domestic Cleaning',
  //   location: 'Aylesbury, Buckinghamshire',
  //   duration: '4 weeks',
  //   year: '2024',
  //   services: ['Web Development', 'CRM Integration', 'Payment Processing'],
  //   challenge: 'Diamond Domestic Cleaning was managing bookings manually and losing customers due to poor communication. They needed a complete digital solution.',
  //   solution: 'We developed an integrated platform with online booking, automated scheduling, customer notifications, and payment processing. Also created a mobile app for field staff.',
  //   results: [
  //     'Business doubled in size within 6 months',
  //     '80% reduction in booking administration time',
  //     '95% customer satisfaction rating',
  //     'Expanded to serve 3 additional towns'
  //   ],
  //   gallery: [
  //     'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1584464491033-06628f3a6b7b?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1527515637462-cff94eecc1ac?w=800&h=600&fit=crop'
  //   ],
  //   testimonial: {
  //     content: "Our cleaning business has doubled since getting our new website. WeDesignedIt made the whole process so easy and stress-free.",
  //     author: 'Mark Stevens',
  //     role: 'Owner, Clean & Bright Services'
  //   },
  //   techStack: ['React.js', 'Node.js', 'MongoDB', 'Stripe', 'Twilio'],
  //   features: [
  //     'Online booking calendar',
  //     'Automated SMS notifications',
  //     'Secure payment processing',
  //     'Customer review system',
  //     'Staff mobile app',
  //     'Route optimization'
  //   ],
  //   url: ''
  // },
  // {
  //   id: 4,
  //   slug: 'aylesbury-electricians',
  //   title: 'Aylesbury Electricians Ltd',
  //   category: 'Electrical Services',
  //   description: 'Emergency-focused website for electrical contractors with 24/7 call-out system and safety certifications.',
  //   shortDescription: 'Professional electrical services website with emergency booking and certification displays.',
  //   image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=600&h=400&fit=crop',
  //   tags: ['Emergency Services', 'Certifications', 'Local SEO', 'Trust Signals'],
  //   client: 'Aylesbury Electricians Ltd',
  //   location: 'Aylesbury, Buckinghamshire',
  //   duration: '2 weeks',
  //   year: '2024',
  //   services: ['Web Design', 'Emergency Booking', 'SEO', 'Trust Building'],
  //   challenge: 'Electrical emergencies require immediate response. The company needed a website that built trust quickly and made it easy for customers to get help fast.',
  //   solution: 'We designed a conversion-focused website emphasizing safety, certifications, and emergency response. Clear call-to-action buttons and trust signals throughout.',
  //   results: [
  //     '400% increase in emergency call-outs',
  //     'Average response time improved to 30 minutes',
  //     'Became top-rated electrician in Aylesbury',
  //     '90% of customers now book through website'
  //   ],
  //   gallery: [
  //     'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1607472586893-edb57bdc0e39?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=800&h=600&fit=crop'
  //   ],
  //   testimonial: {
  //     content: "The new website has transformed our business. We're now the go-to electricians in Aylesbury for both emergency and planned work.",
  //     author: 'James Wilson',
  //     role: 'Director, Aylesbury Electricians Ltd'
  //   },
  //   techStack: ['WordPress', 'PHP', 'Emergency Booking API', 'Google Maps API'],
  //   features: [
  //     '24/7 emergency booking',
  //     'Certification displays',
  //     'Before/after galleries',
  //     'Safety information hub',
  //     'Service area mapping',
  //     'Customer testimonials'
  //   ],
  //   url: ''
  // },
  // {
  //   id: 5,
  //   slug: 'garden-masters-landscaping',
  //   title: 'Garden Masters Landscaping',
  //   category: 'Landscaping Services',
  //   description: 'Stunning visual portfolio website for landscaping company showcasing transformation projects and design services.',
  //   shortDescription: 'Beautiful landscaping portfolio website with project galleries and design consultation booking.',
  //   image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&h=400&fit=crop',
  //   tags: ['Visual Portfolio', 'Image Galleries', 'Design Services', 'Seasonal Marketing'],
  //   client: 'Garden Masters Landscaping',
  //   location: 'Buckinghamshire',
  //   duration: '3 weeks',
  //   year: '2024',
  //   services: ['Web Design', 'Photography', 'Portfolio Development', 'SEO'],
  //   challenge: 'Landscaping is a visual business. Garden Masters needed to showcase their stunning work and attract high-value garden design projects.',
  //   solution: 'We created a visually stunning website with high-quality project galleries, before/after comparisons, and an integrated design consultation booking system.',
  //   results: [
  //     'Increased average project value by 60%',
  //     'Booked solid for next 8 months',
  //     'Won "Best Garden Design" local award',
  //     'Featured in county lifestyle magazine'
  //   ],
  //   gallery: [
  //     'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1585320806297-9794b3e4eeae?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=800&h=600&fit=crop'
  //   ],
  //   testimonial: {
  //     content: "The website perfectly captures the quality of our work. We've never had so many high-value enquiries for design projects.",
  //     author: 'Michael Green',
  //     role: 'Creative Director, Garden Masters'
  //   },
  //   techStack: ['React', 'Gatsby', 'GraphQL', 'Contentful CMS', 'Netlify'],
  //   features: [
  //     'Interactive project galleries',
  //     'Before/after sliders',
  //     'Design consultation booking',
  //     'Seasonal service promotions',
  //     'Plant care guides',
  //     'Maintenance scheduling'
  //   ],
  //   url: 'https://gardenmasters.co.uk'
  // },
  // {
  //   id: 6,
  //   slug: 'premier-roofing-solutions',
  //   title: 'Premier Roofing Solutions',
  //   category: 'Roofing Services',
  //   description: 'Trust-focused website for roofing company with insurance claims assistance and emergency repair booking.',
  //   shortDescription: 'Professional roofing website with emergency services and insurance claims support.',
  //   image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=600&h=400&fit=crop',
  //   tags: ['Emergency Services', 'Insurance Claims', 'Trust Building', 'Weather Integration'],
  //   client: 'Premier Roofing Solutions',
  //   location: 'Aylesbury & Surrounding Areas',
  //   duration: '2.5 weeks',
  //   year: '2024',
  //   services: ['Web Development', 'Emergency Booking', 'Insurance Integration', 'Weather API'],
  //   challenge: 'Roofing emergencies often happen during bad weather. Premier Roofing needed a website that worked perfectly on mobile and built trust quickly.',
  //   solution: 'We built a mobile-first website with weather integration, emergency booking, and detailed insurance claims guidance. Trust signals and certifications prominently displayed.',
  //   results: [
  //     'Became area\'s top emergency roofing service',
  //     '250% increase in storm damage call-outs',
  //     'Partnerships with 3 major insurance companies',
  //     '98% customer satisfaction rating'
  //   ],
  //   gallery: [
  //     'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1448630360428-65456885c650?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&h=600&fit=crop',
  //     'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&h=600&fit=crop'
  //   ],
  //   testimonial: {
  //     content: "During the last storm, our phone didn't stop ringing. The website has made us the go-to roofers for emergency repairs in the area.",
  //     author: 'Robert Taylor',
  //     role: 'Owner, Premier Roofing Solutions'
  //   },
  //   techStack: ['Next.js', 'Weather API', 'Stripe', 'Insurance API Integration'],
  //   features: [
  //     'Weather-triggered emergency alerts',
  //     'Insurance claims assistance',
  //     'Emergency repair booking',
  //     'Certification displays',
  //     'Storm damage assessment',
  //     'Warranty tracking system'
  //   ],
  //   url: 'https://premierroofing.co.uk'
  // }
];

export const getProjectBySlug = (slug) => {
  return projectsData.find(project => project.slug === slug);
};

export const getRelatedProjects = (currentProjectId, category) => {
  return projectsData
    .filter(project => project.id !== currentProjectId && project.category === category)
    .slice(0, 2);
};